import Button from "../common/Button";
import BaseModal from "../modals/BaseModal";

export default function ToggleStatusConfirmModal({
  open,
  member,
  busy,
  onClose,
  onConfirm,
}) {
  if (!member) {
    return null;
  }

  const isCurrentlyActive = member.status?.toLowerCase() === 'active';
  const action = isCurrentlyActive ? 'Deactivate' : 'Activate';
  const buttonVariant = isCurrentlyActive ? 'danger' : 'success';

  return (
    <BaseModal
      open={open}
      onClose={busy ? () => {} : onClose}
      title={`${action} Team Member`}
      meta="This updates the live team roster."
      modalId="toggle-status-team-member-modal"
      className="team-modal team-confirm-modal"
    >
      <div className="team-confirm-copy">
        Are you sure you want to {action.toLowerCase()} this team member?
      </div>
      <div className="modal-summary-block">
        <div className="modal-summary-label">Selected Team Member</div>
        <div className="modal-summary-text">{member.name}</div>
        <div className="modal-summary-text" style={{ fontSize: '14px', marginTop: '4px' }}>
          Current Status: <strong>{member.status}</strong>
        </div>
      </div>
      <div className="modal-actions">
        <Button onClick={onClose} disabled={busy}>
          Cancel
        </Button>
        <Button type="button" variant={buttonVariant} disabled={busy} onClick={onConfirm}>
          {busy ? `${action}ing...` : `Confirm ${action}`}
        </Button>
      </div>
    </BaseModal>
  );
}
